import styled from "styled-components";
import Img from "gatsby-image";
import { width, height, maxWidth, borderRadius, space } from "styled-system";

const Image = styled(Img)(width, height, maxWidth, borderRadius, space);

export default Image;
